module.exports = __webpack_public_path__ + "img/gopro.571aa170.png";